import { Box, Grid, Stack, TextField } from "@mui/material";
import React from "react";
import boxStyles from "../../styles/boxStyles";

const CreateApplicationConfig = ({
  inputFields,
  setInputFields,
  readOnly = false,
  action,
}) => {
  return (
    <>
      <Box sx={boxStyles}>
        <Grid container spacing={3}>
          <Grid item xl={12} lg={12} sm={12} xs={12}>
            <Stack spacing={2}>
              <TextField
                name="configName"
                label="Config Name"
                variant="standard"
                fullWidth
                value={inputFields.configName ? inputFields.configName : ""}
                InputLabelProps={{ shrink: inputFields.configName !== "" }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    configName: e.target.value,
                  })
                }
                disabled={readOnly}
              />
              <TextField
                name="configValue"
                label="Config Value"
                variant="standard"
                fullWidth
                value={inputFields.configValue ? inputFields.configValue : ""}
                InputLabelProps={{ shrink: inputFields.configValue !== "" }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    configValue: e.target.value,
                  })
                }
                disabled={readOnly}
              />
              <TextField
                id="outlined-multiline-flexible"
                label="Remark"
                multiline
                maxRows={10}
                value={inputFields.remark ? inputFields.remark : ""}
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    remark: e.target.value,
                  });
                }}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CreateApplicationConfig;
